<template>
    <Head title="Error" />
    <div class="flex flex-col mt-6 items-center h-screen gap-6">
        <div class="max-w-36">
            <OrganizationLogo />
        </div>
        <h3 class="title-subsection">{{ errorType }}</h3>
        <div class="flex flex-col items-center text-center rounded-xl py-10 px-6 max-w-80 sm:max-w-96 gap-6 border-2 border-[#F5F5F5] shadow-lg bg-white">
            <div class="w-32 h-32">
                <CoachingModeMarble />
            </div>
            <h3 class="title-subsection">Something went wrong</h3>
            <p class="body text-valence-grey-750">{{ errorMessage }}</p>
            <BaseButton class="w-4/5" theme="primary" @click="openUrl(url)">{{ cta_text }}</BaseButton>
        </div>
        <span>
            <PrivacyDialog />
        </span>
    </div>
    <Bubbles direction="bottom" direction-md="top" />
</template>

<script setup>
import { Head } from "@inertiajs/vue3";
import BaseButton from "~vue/components/BaseButton.vue";
import Bubbles from "~vue/components/Bubbles.vue";
import CoachingModeMarble from "~vue/components/navigation/CoachingModeMarble.vue";
import OrganizationLogo from "~vue/components/OrganizationLogo.vue";
import PrivacyDialog from "~vue/Onboarding/PrivacyDialog.vue";
import { isInIFrame, openUrl } from "~vue/utils";
import { computed } from "vue";

const props = defineProps({
    errorType: { type: String, default: "Server Error" },
    errorMessage: { type: String, default: "Sorry! I ran into a server error and need to reboot. Please try again" },
    cta_text: { type: String, default: "Go to Home" },
    cta_url: { type: String, default: "" },
});

const url = computed(() => {
    if (props.cta_url === "") {
        return isInIFrame() ? "/?client=teams" : "/";
    }

    return props.cta_url;
});
</script>
